import {View, Text, StyleSheet, ScrollView} from 'react-native';
import React, {useEffect, useState} from 'react';
import {connect, useSelector} from 'react-redux';
import {
  mob_link,
  mob_refer_market,
  mob_walletrefer,
   refer_new,
  smile_coin,
} from '../../utils/images';
import {globalFontStyle, globalStyle} from '../../assets';
import Colors from '../../assets/Color/Colors';
import Header from '../../commonComponents/Header';
import {getReferralData} from '../Profile/redux/profile.action';
import LottieComp from '../../commonComponents/Lottie';
import FAQ from '../../commonComponents/FAQ';
import {
  generateInviteLink,
  trackMoengageEvent,
} from '../../utils/commonMethods';
import {INDIA, REST_OF_WORLD} from '../../utils/constants';
import {SafeAreaView} from 'react-native-safe-area-context';
import FastImage from '../../common/FastImage';
import ShareLinkButton from './shareLinkButton';
import FormTextLabel from '../../commonComponents/FormTextLabel';
import {globalConfigurableData} from "../../utils/globalConstant";
import NEWFAQ from "../../commonComponents/newFAQ";

const Refer = ({navigation, fetchRequest, referralData}) => {
  const [isCopyApply, setIsCopyApply] = useState(false);

  let userInfo = useSelector(({profile}) => profile?.profileData);
  const region = userInfo?.region_code ?? 'INDIA';

  const referTimeline = [
    {
      img: mob_link(),
      text: 'Invite your friend to register on the app with your code',
    },
    {
      img: mob_refer_market(),
      text: userInfo?.userConfig?.RefernEarnText,
    },
    {
      img: mob_walletrefer(),
      text: userInfo?.userConfig?.RefernEarnText2,
    },
  ];

  useEffect(() => {
    if (isCopyApply) {
      setTimeout(() => {
        setIsCopyApply(false);
      }, 2000);
    }
  }, [isCopyApply]);

  useEffect(() => {
    trackMoengageEvent('Page Visit', {
      Page: 'Refer & Earn',
    });
    fetchRequest();
  }, []);

  const percentage = referralData?.referral_percentage;
  const total_earning = referralData?.total_referral_earning
    ? (referralData?.total_referral_earning).toFixed(2)
    : 0;
  const referred_users = referralData?.total_referred_users;

  const coupon = userInfo?.coupon;
  const totalRedeemedAmount = referralData?.total_redeemed_amount
    ? referralData?.total_redeemed_amount.toFixed(2)
    : 0;
  const totalSmileCoins = referralData?.total_referral_promo_earning
    ? referralData?.total_referral_promo_earning.toFixed(2)
    : 0;

  const title = referralData?.title ? referralData?.title :  'Refer your friends & earn token points!';
  const sub_title = referralData?.sub_title ? referralData?.sub_title : 'Get token points daily based on your friends trading fees. Token points will be updated daily at 6 pm IST.';

  const onShareLinkClick = () => {
    generateInviteLink(
      coupon,
      region,
      userInfo?.displayname,
      userInfo?.userid,
      userInfo?.userConfig?.whatsappReferMessage,
    );
  };

  useEffect(() => {
    referralData &&
      trackMoengageEvent('Clicked on Referral Page', {
        TotalReferralEarnings: total_earning,
        TotalReferredUsers: referred_users,
        TotalRedeemedAmount: totalRedeemedAmount,
      });
  }, [referralData]);

  return (
    <SafeAreaView
      style={[
        globalStyle.pageContainer,
        {flexGrow: 1, backgroundColor: globalConfigurableData.globalThemeColor},
      ]}>
      <Header
        isInternalPage={false}
        navigation={navigation}
        pageName={'Refer & Earn'}
        isBackgroundColor={false}
        translate={true}
      />
      <ScrollView
        style={{
          paddingBottom: 22,
          flexGrow: 1,
          backgroundColor: Colors.bgWhite,
        }}
        showsVerticalScrollIndicator={false}
        contentContainerStyle={{flexGrow: 1}}>
          <View
            style={{
              flexDirection: 'row',
              justifyContent: 'space-between',
              paddingTop: 20,
              paddingLeft: 16,
            }}>
            <View style={{flex: 5}}>
              <View style={{flex: 1, flexDirection: 'row'}}>
                <View>
                  <FormTextLabel
                      labelStyles={{
                        ...globalFontStyle.appFontSubHeading,
                        backgroundColor: globalConfigurableData?.primaryBtnColor,
                        color: globalConfigurableData.primaryBtnTxt,
                        paddingHorizontal: 8,
                        paddingVertical: 6,
                        borderRadius: 2,
                        marginBottom: 15,
                        justifyContent: 'center',
                      }}
                    label={'NEW & EXCITING'}/>
                </View>
              </View>
              {/*<View style={{flex: 1}}/>*/}
              <Text style={{
                ...globalFontStyle.appFontTitle,
                color: globalConfigurableData.primaryTextColor1,
                marginBottom: 10,
              }}>
                {title}
              </Text>
              <Text style={{
                ...globalFontStyle.appFontBody,
                color: globalConfigurableData.secondaryTextColor1
              }}>
                {sub_title}
              </Text>
            </View>
            <View style={{flex: 3}}>
              <View style={styles.refer_img_box}>
                <FastImage source={refer_new()} style={{height: 170, width: 170}} />
              </View>
            </View>
          </View>
        <View
          style={{
            backgroundColor: Colors.bgWhite,
            zIndex: 1000,
            paddingHorizontal: 16,
            paddingTop: 20,
            paddingBottom: 25
          }}>
          <View style={{
            borderColor: 'rgba(0, 0, 0, 0.2)',
            borderWidth: 0.5,
            borderRadius: 8,
            backgroundColor: "#F9F9F9"
          }}>
            <View style={[
                styles.details_box,
              {borderColor: 'rgba(0, 0, 0, 0.2)',
                borderBottomWidth: 0.5,}
            ]}>
              <FormTextLabel
                labelStyles={styles.details_heading}
                label={'Tokens Earned'}
              />
              <View
                  style={{
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}>
                <FastImage
                    style={{width: 15, height: 15, marginRight: 2}}
                    source={smile_coin()}
                />
                <Text style={styles.details_Value}> {totalSmileCoins}</Text>
              </View>
            </View>
            <View style={styles.details_box}>
              <FormTextLabel
                labelStyles={styles.details_heading}
                label={'Total Referred Users'}
              />
              <Text style={styles.details_Value}> {referred_users}</Text>
            </View>
          </View>
          {/* <View style={{flexDirection: 'row', gap: 15}}>
            <View style={styles.details_box}>
              <Text style={styles.details_Value}> {totalRedeemedAmount}</Text>
              <FormTextLabel
                labelStyles={styles.details_heading}
                label={'Redeemed Credits'}
              />
            </View>
            <View style={styles.details_box}>
              <View
                style={{
                  flexDirection: 'row',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}>
                <FastImage
                  style={{width: 10, height: 10, marginRight: 2}}
                  source={smile_coin()}
                />
                <Text style={styles.details_Value}> {totalSmileCoins}</Text>
              </View>
              <FormTextLabel
                labelStyles={styles.details_heading}
                label={'Token Points Earned'}
              />
            </View>
          </View> */}
        </View>

        <ShareLinkButton
            coupon={coupon}
            onShareLinkClick={onShareLinkClick}
            referText={userInfo?.userConfig?.whatsappReferMessage}
        />

        {/*<View style={{paddingHorizontal: 18}}>*/}
        {/*  <FormTextLabel*/}
        {/*    labelStyles={{*/}
        {/*      ...globalFontStyle.appFontHeading,*/}
        {/*      color: Colors.black,*/}
        {/*      marginBottom: 15,*/}
        {/*    }}*/}
        {/*    label={'How it Works?'}*/}
        {/*  />*/}
        {/*  {referTimeline.map(item => {*/}
        {/*    return (*/}
        {/*      <View style={styles.mob_refer_how_item}>*/}
        {/*        <View style={styles.mob_refer_how_img}>*/}
        {/*          /!* <SvgUri*/}
        {/*            width="15"*/}
        {/*            height="15"*/}
        {/*            uri={resolveAssetSource(item.img).uri}*/}
        {/*          /> *!/*/}
        {/*          <FastImage*/}
        {/*            style={{height: 20, width: 20}}*/}
        {/*            source={item.img}*/}
        {/*          />*/}
        {/*        </View>*/}
        {/*        <FormTextLabel*/}
        {/*          labelStyles={{*/}
        {/*            ...globalFontStyle.appFontSubText,*/}
        {/*            color: Colors.grey,*/}
        {/*            flex: 1,*/}
        {/*          }}*/}
        {/*          label={item?.text}*/}
        {/*          rest={{percent: percentage}}*/}
        {/*        />*/}
        {/*      </View>*/}
        {/*    );*/}
        {/*  })}*/}
        {/*</View>*/}
        <NEWFAQ faqtype={'refer'} />
      </ScrollView>
    </SafeAreaView>
  );
};

const mapStateToProps = ({profile}) => ({
  referralData: profile.referralData,
});
const mapDispatchToProps = dispatch => ({
  fetchRequest: () => {
    dispatch(getReferralData());
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Refer);

const styles = StyleSheet.create({
  mob_refer_how_item: {
    marginBottom: 20,
    alignItems: 'center',
    flexDirection: 'row',
  },
  mob_refer_how_img: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    height: 50,
    width: 50,
    marginBottom: 0,
    marginRight: 20,
    borderRadius: 50,
    backgroundColor: 'rgba(10, 87, 255, 0.05)',
  },
  details_heading: {
    ...globalFontStyle.appFontBody,
    color: Colors.lightgrey,
  },
  details_Value: {
    ...globalFontStyle.appFontSubHeading,
    color: Colors.black,
  },

  details_box: {
    paddingVertical: 15,
    paddingHorizontal: 15,
    flex: 1,
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center"
  },
  info_bar: {
    ...globalFontStyle.appFontSmallText,
    color: Colors.black,
    fontStyle: 'italic',
    paddingHorizontal: 18,
    paddingVertical: 10,
    backgroundColor: 'white',
    alignItems: 'center',
    borderColor: 'rgba(0, 0, 0, 0.2)',
    borderWidth: 0.2,
    marginLeft: -18,
    borderBottomRightRadius: 50,
    borderTopRightRadius: 50,
    width: 200,
    marginTop: 25,
  },
  share_button: {
    flex: 0,
    alignItems: 'center',
    backgroundColor: Colors.tradexBlue,
    borderRadius: 50,
    paddingHorizontal: 12,
    paddingVertical: 8,
    width: 110,
    flexDirection: 'row',
  },
  refer_img_box: {
  },
});
